import { api } from './api'

export type Asset = {
  id: string
  timestamp: number
  model:
    | 'CUSTOM_UPLOAD_01'
    | 'ANVDNI'
    | 'REVDNI'
    | 'BANKRECEIPT'
    | 'ANVMOBILE'
    | 'REVMOBILE'
    | ''
  mime: string
  ext: string
  name: string
  content: string
}
const sendDocument = (asset: Asset) => {
  return api.post(`/callbacks/identification/assets`, asset).then((response) => {
    const data = response.data
    return data
  })
}

const uploadDocumentService = {
  sendDocument
}

export default uploadDocumentService
